exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeinput {\n  width: 45px;\n}\n.high-row {\n  height: 42px;\n}\n.lighter-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n  color: #c4c4c4;\n}\n.lighter-input::-moz-placeholder { /* Firefox 19+ */\n  color: #c4c4c4;\n}\n.lighter-input:-ms-input-placeholder { /* IE 10+ */\n  color: #c4c4c4;\n}\n.lighter-input:-moz-placeholder { /* Firefox 18- */\n  color: #c4c4c4;\n}", ""]);

// exports
